export const template7MockData = {
  businessName: "Your Business Name",
  description: "Your business description goes here. Provide exceptional services and products tailored to your needs.",
  services: [
    {
      title: "Consulting Services",
      description: "Expert guidance and strategic planning to help your business grow and succeed in competitive markets.",
      icon: "Users"
    },
    {
      title: "Digital Marketing", 
      description: "Comprehensive digital marketing solutions including SEO, social media, and content marketing strategies.",
      icon: "Target"
    },
    {
      title: "Technology Solutions",
      description: "Cutting-edge technology implementations and custom software development for modern businesses.",
      icon: "Zap"
    },
    {
      title: "Security Services",
      description: "Advanced cybersecurity solutions to protect your business data and maintain customer trust.",
      icon: "Shield"
    }
  ],
  products: [
    {
      name: "Premium Business Package",
      price: "$299",
      rating: 4.9,
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_4.png",
      description: "Complete business solution with advanced features and premium support."
    },
    {
      name: "Starter Solution",
      price: "$99", 
      rating: 4.7,
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_3.png",
      description: "Perfect for small businesses looking to establish their digital presence."
    },
    {
      name: "Enterprise Suite",
      price: "$599",
      rating: 5.0,
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_1.png", 
      description: "Comprehensive enterprise-level solution with custom integrations."
    }
  ],
  contact: {
    address: "123 Business Street, City, State 12345",
    phone: "(555) 123-4567",
    email: "contact@yourbusiness.com",
    hours: "Mon - Fri: 9:00 AM - 6:00 PM, Sat: 10:00 AM - 4:00 PM, Sun: Closed"
  },
  reviews: [
    {
      name: "Sarah Johnson",
      role: "CEO, TechStart Inc.",
      rating: 5,
      comment: "Exceptional service and outstanding results. Their team exceeded our expectations and delivered exactly what we needed for our business growth.",
      avatar: "https://placehold.co/60x60"
    },
    {
      name: "Michael Chen", 
      role: "Marketing Director",
      rating: 5,
      comment: "Professional, reliable, and innovative. Working with them has been a game-changer for our digital presence and customer engagement.",
      avatar: "https://placehold.co/60x60"
    },
    {
      name: "Emily Rodriguez",
      role: "Small Business Owner", 
      rating: 4,
      comment: "Great value for money and excellent customer support. They helped us streamline our operations and improve our bottom line significantly.",
      avatar: "https://placehold.co/60x60"
    }
  ],
  feedPosts: [
    {
      title: "New Product Launch Success",
      excerpt: "We are excited to announce the successful launch of our latest product line, featuring innovative solutions...",
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_4.png",
      date: "2024-01-15",
      category: "Product News"
    },
    {
      title: "Team Expansion Update", 
      excerpt: "Our team continues to grow with talented professionals joining our mission to deliver exceptional services...",
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_3.png",
      date: "2024-01-10",
      category: "Company News"
    },
    {
      title: "Industry Recognition Award",
      excerpt: "We are honored to receive recognition for our innovative approach and commitment to excellence in the industry...",
      image: "https://c.animaapp.com/mffcpu90bnu9dd/img/ai_1.png",
      date: "2024-01-05", 
      category: "Awards"
    }
  ],
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "123 Business Street, City, State"
  }
};
